import React from 'react';
import Header from './Header';

const Layout = ({ children, signOut, user }) => {
  return (
    <div className="app-layout">
      <Header signOut={signOut} user={user} />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default Layout;